import { Us2MapPin } from '@uswitch/spark-icons/us2'
import React from 'react'

import * as styles from './styles'

const StickyHeader = (props) => (
  <div {...props} sx={styles.container} data-homepage-scroll-target='stickyHeader'>
    <div sx={styles.headerContent}>
      <div sx={styles.heading}>
        <span sx={styles.iconContainer}>
          <Us2MapPin sx={styles.icon} />
        </span>

        <div sx={styles.headingText}>Check what's in your area</div>
      </div>

      <div>
        <p sx={styles.subheading}>
          <span sx={styles.link}>Add your postcode</span> and we'll search for deals where you live.
        </p>
      </div>
    </div>
  </div>
)

export default StickyHeader
